import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectorComponent, UiModule } from '@lockton-apps/shared/ui/lui';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@lockton-apps/material';
import { BehaviorSubject } from 'rxjs';
import { filter, startsWith, toLower } from 'lodash';
import { MatInput } from '@angular/material/input';

interface InlineSearchItem {
  id: string;
  label: string;
  icon?: string;
  searchString: string;
  value: any;
}

@Component({
    selector: 'la-dynamic-table-inline-search',
    imports: [CommonModule, UiModule, MaterialModule, ReactiveFormsModule],
    templateUrl: './dynamic-table-inline-search.component.html',
    styleUrls: ['./dynamic-table-inline-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicTableInlineSearchComponent
  implements OnChanges, AfterViewInit
{
  @ViewChild(MatInput) searchInput!: MatInput;
  @ViewChild(SelectorComponent) selector!: SelectorComponent;

  @Input() value!: string;
  @Input() placeholder!: string;
  @Input() items!: InlineSearchItem[];
  @Output() valueChange: EventEmitter<string> = new EventEmitter();
  @Output() selectionChange: EventEmitter<InlineSearchItem> =
    new EventEmitter();
  @Output() event = new EventEmitter<{ id: string; event: unknown }>();

  filteredItems$!: BehaviorSubject<InlineSearchItem[]>;

  ngOnChanges(): void {
    this.filteredItems$ = new BehaviorSubject(this.items);
  }

  ngAfterViewInit(): void {
    this.searchInput.focus();
  }

  onSearch(term: string): void {
    this.filteredItems$.next(
      filter(this.items, (item) => startsWith(item.searchString, toLower(term)))
    );
  }

  onValueChange(value: unknown): void {
    if (value === this.value) {
      return;
    }

    this.valueChange.emit(value as string);
    const item = this.items.find((i) => i.id === value);
    this.selectionChange.emit(item);

    item &&
      this.event.emit({
        id: 'selectionChange',
        event: item.value,
      });
  }
}
